// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1E-nE","disabled":"FileBtn_disabled__vpWsJ","warn":"FileBtn_warn__3ePRD","fade":"FileBtn_fade__3SWRw"};